import Highcharts from 'highcharts';

export const createDefaultRangeSelectorOptions = (
): Highcharts.ScrollbarOptions => ({
  enabled: false,
});
